import React from "react";
import loading from "../../../assets/img/auth/animated_logo.gif";

const Loader = () => {
  return (
    <div className="flex justify-center bg-white items-center min-h-screen">
      <img
        className="object-contain h-40 md:h-72 w-auto"
        src={loading}
        alt="loader_gif"
      />
    </div>
  );
};
export default Loader;

